window.setSpinner = function(){
  return("<div class='w-100 d-flex justify-content-center mt-2'><div class='spinner-border spinner-border-sm text-primary'></div></div>")
}

window.setScannerModal = function(){
  return("<div id='scan-message'><p class='text-center px-5 py-3 bg-info rounded text-white'>Anda sudah bisa mulai scan kode QR</p></div>")
}

window.setCounterRegularModal = function(){
  return("<div id='scan-message'><p class='text-center px-5 py-3 bg-info rounded text-white'>Anda sudah bisa mulai scan barcode label internal</p></div>")
}